import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Chip from "@material-ui/core/Chip";
import Box from "@material-ui/core/Box";
import Alert from "@material-ui/lab/Alert";
import InfoIcon from "@material-ui/icons/Info";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import SendIcon from "@material-ui/icons/Send";
import MessageIcon from "@material-ui/icons/Message";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import CodeIcon from "@material-ui/icons/Code";
import PollIcon from "@material-ui/icons/Poll";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import CameraAltOutlinedIcon from "@material-ui/icons/CameraAltOutlined";

import { i18n } from "../../translate/i18n";
import GuideOpenButton from "../../components/GuideOpenButton";
import { Button, CircularProgress, Grid, TextField, Typography } from "@material-ui/core";
// ✅ REMOVIDO: Formik ya no se usa después de la solución con useState
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import axios from "axios";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  // ✅ CORREGIDO: MainPaper dinámico según tema
  mainPaper: {
    flex: 1,
    padding: theme.spacing(3),
    paddingBottom: 100,
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#f8f9fa',
    borderRadius: '12px',
    boxShadow: theme.mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.1)',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
  },
  // ✅ CORREGIDO: MainHeader dinámico según tema
  mainHeader: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 12,
  },
  // ✅ CORREGIDO: SectionCard dinámico según tema
  sectionCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: theme.mode === 'dark' ? '0 4px 6px rgba(0, 0, 0, 0.3)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e1e5e9'}`,
    backgroundColor: theme.palette.background.paper,
  },
  // ✅ CORREGIDO: SectionHeader dinámico según tema
  sectionHeader: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: '12px 12px 0 0'
  },
  formContainer: {
    maxWidth: 500,
    padding: theme.spacing(2)
  },
  textRight: {
    textAlign: "right"
  },
  // ✅ CORREGIDO: InfoBox dinámico según tema
  infoBox: {
    backgroundColor: theme.mode === 'dark' ? '#1e3a5f' : '#e8f4fd',
    border: `1px solid ${theme.mode === 'dark' ? '#2d4f7a' : '#bee5eb'}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: theme.mode === 'dark' ? theme.palette.primary.light : '#1976d2',
  },
  // ✅ CORREGIDO: FileUploadArea dinámico según tema
  fileUploadArea: {
    border: `2px dashed ${theme.palette.primary.main}`,
    borderRadius: 8,
    padding: theme.spacing(3),
    textAlign: 'center',
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa',
    color: theme.palette.text.primary,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#e3f2fd',
      borderColor: theme.palette.primary.dark || '#2980b9'
    }
  },
  // ✅ CORREGIDO: FileInfo dinámico según tema
  fileInfo: {
    marginTop: theme.spacing(1),
    fontSize: '0.875rem',
    color: theme.palette.text.secondary || theme.palette.text.primary,
  },
  // ✅ CORREGIDO: EndpointBox dinámico según tema
  endpointBox: {
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#2c3e50',
    color: 'white',
    padding: theme.spacing(1),
    borderRadius: 4,
    fontFamily: 'monospace',
    fontSize: '0.875rem',
    margin: theme.spacing(1, 0)
  },
  limitChip: {
    backgroundColor: '#27ae60',
    color: 'white',
    fontWeight: 'bold'
  },
  methodChip: {
    backgroundColor: '#e74c3c',
    color: 'white',
    fontWeight: 'bold'
  },
  headerChip: {
    backgroundColor: '#9b59b6',
    color: 'white',
    fontWeight: 'bold'
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
  buttonProgress: {
    color: theme.palette.success.main,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  btnWrapper: {
    position: "relative",
  },
  elementMargin: {
    marginBottom: theme.spacing(2),
  },
}));

const GROUP_MESSAGE_ENDPOINT_WHATSAPP_ID = "token";

const MessagesAPI = () => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const { user } = useContext(AuthContext);
  const companyId = user?.companyId;

  // ✅ REMOVIDO: Variables de estado que ya no se usan después de la solución con useState
  const [file, setFile] = useState({})
  const [selectedFileName, setSelectedFileName] = useState('')
  
  // ✅ SOLUCIÓN RADICAL: Estados separados para formulario de texto
  const [textToken, setTextToken] = useState('')
  const [textNumber, setTextNumber] = useState('')
  const [textBody, setTextBody] = useState('')
  const [isSubmittingText, setIsSubmittingText] = useState(false)
  
  // ✅ SOLUCIÓN RADICAL: Estados separados para formulario multimedia
  const [mediaToken, setMediaToken] = useState('')
  const [mediaNumber, setMediaNumber] = useState('')
  const [mediaBody, setMediaBody] = useState('')
  const [isSubmittingMedia, setIsSubmittingMedia] = useState(false)
  
  // ✅ SECCIÓN 3: Estados para formulario de grupos
  const [groupToken, setGroupToken] = useState('')
  const [groupId, setGroupId] = useState('')
  const [groupBody, setGroupBody] = useState('')
  const [isSubmittingGroup, setIsSubmittingGroup] = useState(false)
  
  // ✅ SECCIÓN 4: Estados para envío multimedia a grupos
  const [groupMediaToken, setGroupMediaToken] = useState('')
  const [groupMediaId, setGroupMediaId] = useState('')
  const [groupMediaBody, setGroupMediaBody] = useState('')
  const [groupMediaFile, setGroupMediaFile] = useState({})
  const [groupMediaFileName, setGroupMediaFileName] = useState('')
  const [isSubmittingGroupMedia, setIsSubmittingGroupMedia] = useState(false)

  // Sección 5: canales WhatsApp
  const [channelToken, setChannelToken] = useState('')
  const [channelWhatsappId, setChannelWhatsappId] = useState('')
  const [channelJid, setChannelJid] = useState('')
  const [channelMode, setChannelMode] = useState('text')
  const [channelBody, setChannelBody] = useState('')
  const [channelOptions, setChannelOptions] = useState('')
  const [channelSelectableCount, setChannelSelectableCount] = useState('1')
  const [channelMedia, setChannelMedia] = useState(null)
  const [isSubmittingChannel, setIsSubmittingChannel] = useState(false)

  // Sección 6: encuesta/pregunta/cuestionario a contactos
  const [pollToken, setPollToken] = useState('')
  const [pollNumber, setPollNumber] = useState('')
  const [pollQuestion, setPollQuestion] = useState('')
  const [pollOptions, setPollOptions] = useState('')
  const [pollSelectableCount, setPollSelectableCount] = useState('1')
  const [isSubmittingPoll, setIsSubmittingPoll] = useState(false)
  const [statusToken, setStatusToken] = useState("")
  const [statusTarget, setStatusTarget] = useState("all")
  const [statusContacts, setStatusContacts] = useState("")
  const [statusBody, setStatusBody] = useState("")
  const [statusMedia, setStatusMedia] = useState(null)
  const [isSubmittingStatus, setIsSubmittingStatus] = useState(false)

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      if (companyId) {
        const planConfigs = await getPlanCompany(undefined, companyId);
        if (!planConfigs.plan.useExternalApi) {
          toast.error(i18n.t("messagesAPI.messages.noPermission"));
          setTimeout(() => {
            history.push(`/`)
          }, 1000);
        }
      }
    }
    fetchData();
    if (window.location.hash === "#estados") {
      setTimeout(() => document.getElementById("estados")?.scrollIntoView({ behavior: "smooth", block: "start" }), 300);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getEndpoint = () => {
    const backendUrl = (typeof process !== 'undefined' && process.env) ? process.env.REACT_APP_BACKEND_URL : 'http://localhost:8080';
    if (!backendUrl) {
      throw new Error(i18n.t('messagesAPI.errors.backendUrlNotConfigured'));
    }
    return backendUrl + '/api/messages/send'
  }

  const getExternalApiBase = () => {
    const backendUrl = (typeof process !== 'undefined' && process.env) ? process.env.REACT_APP_BACKEND_URL : 'http://localhost:8080';
    return (backendUrl || 'http://localhost:8080') + '/api/external'
  }

  // ✅ SOLUCIÓN RADICAL: Función simplificada para mensajes de texto
  const handleSendTextMessageSimple = async () => {
    const data = { number: textNumber, body: textBody };
    
    // ✅ DEBUG: Log de la petición que se va a enviar
    console.log('🔍 DEBUG Frontend Simple - URL:', getEndpoint());
    console.log('🔍 DEBUG Frontend Simple - Data:', data);
    console.log('🔍 DEBUG Frontend Simple - Token:', textToken);
    console.log('🔍 DEBUG Frontend Simple - Token length:', textToken ? textToken.length : 'UNDEFINED');
    
    setIsSubmittingText(true);
    
    try {
      const response = await axios.request({
        url: getEndpoint(),
        method: 'POST',
        data,
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${textToken}`
        }
      })
      
      console.log('✅ DEBUG Frontend Simple - Response:', response.data);
      toast.success(i18n.t("messagesAPI.messages.success"));
      
      // Limpiar formulario
      setTextToken('');
      setTextNumber('');
      setTextBody('');
      
    } catch (err) {
      console.log('❌ DEBUG Frontend Simple - Error:', err.response?.data || err.message);
      toastError(err);
    } finally {
      setIsSubmittingText(false);
    }
  }

  // ✅ REMOVIDO: Función que ya no se usa después de la solución con useState

  // ✅ SOLUCIÓN RADICAL: Función simplificada para mensajes multimedia
  const handleSendMediaMessageSimple = async () => {
    try {
      const firstFile = file[0];
      const data = new FormData();
      data.append('number', mediaNumber);
      data.append('medias', firstFile);
      
      // ✅ MEJORA: Agregar mensaje opcional si está presente
      if (mediaBody && mediaBody.trim()) {
        data.append('body', mediaBody.trim());
        console.log('🔍 DEBUG Frontend Media Simple - Mensaje incluido:', mediaBody);
      } else {
        console.log('🔍 DEBUG Frontend Media Simple - Sin mensaje adicional');
      }
      
      console.log('🔍 DEBUG Frontend Media Simple - File:', firstFile.name, 'Size:', firstFile.size);
      console.log('🔍 DEBUG Frontend Media Simple - Token:', mediaToken);
      console.log('🔍 DEBUG Frontend Media Simple - Token length:', mediaToken ? mediaToken.length : 'UNDEFINED');
      
      setIsSubmittingMedia(true);
      
      await axios.request({
        url: getEndpoint(),
        method: 'POST',
        data,
        headers: {
          'Content-type': 'multipart/form-data',
          'Authorization': `Bearer ${mediaToken}`
        }
      })
      
      toast.success(i18n.t("messagesAPI.messages.successMedia"));
      
      // Limpiar formulario
      setMediaToken('');
      setMediaNumber('');
      setMediaBody('');
      setFile({});
      setSelectedFileName('');
      document.getElementById('medias').files = null;
      document.getElementById('medias').value = null;
      
    } catch (err) {
      console.log('❌ DEBUG Frontend Media Simple - Error:', err.response?.data || err.message);
      toastError(err);
    } finally {
      setIsSubmittingMedia(false);
    }
  }

  // ✅ REMOVIDO: Función que ya no se usa después de la solución con useState

  const handleFileChange = (e) => {
    const files = e.target.files;
    setFile(files);
    if (files && files[0]) {
      setSelectedFileName(files[0].name);
    } else {
      setSelectedFileName('');
    }
  }

  const formatFileSize = (bytes) => {
    if (bytes === 0) return `0 ${i18n.t('messagesAPI.fileSize.bytes')}`;
    const k = 1024;
    const sizes = [
      i18n.t('messagesAPI.fileSize.bytes'),
      i18n.t('messagesAPI.fileSize.kb'),
      i18n.t('messagesAPI.fileSize.mb'),
      i18n.t('messagesAPI.fileSize.gb'),
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
  }

  // ✅ SECCIÓN 3: Función para enviar mensajes a grupos
  const handleSendGroupMessage = async () => {
    // Construir URL correctamente - usar REACT_APP_BACKEND_URL directamente
    const backendUrl = (typeof process !== 'undefined' && process.env) ? process.env.REACT_APP_BACKEND_URL : 'http://localhost:8080';
    const url = `${backendUrl}/api/messages/send-group/${GROUP_MESSAGE_ENDPOINT_WHATSAPP_ID}`;
    
    const data = { 
      number: groupId,
      body: groupBody
    };
    
    console.log('🔍 [GroupSend] Backend URL:', backendUrl);
    console.log('🔍 [GroupSend] Final URL:', url);
    console.log('🔍 [GroupSend] Data:', data);
    
    setIsSubmittingGroup(true);
    
    try {
      const response = await axios.post(url, data, {
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${groupToken}`
        }
      });
      
      console.log('✅ [GroupSend] Respuesta:', response.data);
      toast.success(i18n.t("messagesAPI.messages.successGroup"));
      setGroupId('');
      setGroupBody('');
    } catch (err) {
      console.error('❌ [GroupSend] Error completo:', err);
      console.error('❌ [GroupSend] Error URL intentada:', url);
      console.error('❌ [GroupSend] Error response:', err.response?.data);
      console.error('❌ [GroupSend] Error status:', err.response?.status);
      toast.error(err.response?.data?.error || i18n.t("messagesAPI.messages.groupSendError"));
    } finally {
      setIsSubmittingGroup(false);
    }
  }

  // ✅ SECCIÓN 4: Función para enviar multimedia a grupos
  const handleSendGroupMedia = async () => {
    const backendUrl = (typeof process !== 'undefined' && process.env) ? process.env.REACT_APP_BACKEND_URL : 'http://localhost:8080';
    const url = `${backendUrl}/api/messages/send-group/${GROUP_MESSAGE_ENDPOINT_WHATSAPP_ID}`;
    
    try {
      const firstFile = groupMediaFile[0];
      const data = new FormData();
      data.append('number', groupMediaId);
      data.append('medias', firstFile);
      
      // Mensaje opcional para grupos
      if (groupMediaBody && groupMediaBody.trim()) {
        data.append('body', groupMediaBody.trim());
      }
      
      console.log('🔍 [GroupMediaSend] URL:', url);
      console.log('🔍 [GroupMediaSend] File:', firstFile.name);
      
      setIsSubmittingGroupMedia(true);
      
      await axios.post(url, data, {
        headers: {
          'Content-type': 'multipart/form-data',
          'Authorization': `Bearer ${groupMediaToken}`
        }
      });
      
      console.log('✅ [GroupMediaSend] Mensaje multimedia enviado a grupo');
      toast.success(i18n.t("messagesAPI.messages.successGroupMedia"));
      
      // Limpiar formulario
      setGroupMediaToken('');
      setGroupMediaId('');
      setGroupMediaBody('');
      setGroupMediaFile({});
      setGroupMediaFileName('');
      
    } catch (err) {
      console.error('❌ [GroupMediaSend] Error:', err);
      toast.error(err.response?.data?.error || i18n.t("messagesAPI.messages.groupMediaError"));
    } finally {
      setIsSubmittingGroupMedia(false);
    }
  }

  const handleGroupMediaFileChange = (e) => {
    const files = e.target.files;
    setGroupMediaFile(files);
    if (files && files[0]) {
      setGroupMediaFileName(files[0].name);
    } else {
      setGroupMediaFileName('');
    }
  }

  const parsePollOptions = () => pollOptions
    .split(/\r?\n|,/)
    .map(option => option.trim())
    .filter((option, index, all) => option && all.indexOf(option) === index);

  const handleSendPoll = async () => {
    const options = parsePollOptions();

    if (options.length < 2) {
      toast.error(i18n.t("messagesAPI.messages.pollOptionsError"));
      return;
    }

    setIsSubmittingPoll(true);

    try {
      await axios.request({
        url: getEndpoint(),
        method: 'POST',
        data: {
          type: 'poll',
          number: pollNumber,
          question: pollQuestion,
          options,
          selectableCount: Number(pollSelectableCount)
        },
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${pollToken}`
        }
      });

      toast.success(i18n.t("messagesAPI.messages.successPoll"));
      setPollNumber('');
      setPollQuestion('');
      setPollOptions('');
      setPollSelectableCount('1');
    } catch (err) {
      toastError(err);
    } finally {
      setIsSubmittingPoll(false);
    }
  }

  const parseChannelOptions = () => channelOptions
    .split(/\r?\n|,/)
    .map(option => option.trim())
    .filter((option, index, all) => option && all.indexOf(option) === index);

  const getNewsletterEndpoint = () =>
    `${getEndpoint().replace(/\/send$/, '')}/send-newsletter/${channelWhatsappId || ':whatsappId'}`;

  const handleSendChannel = async () => {
    const options = parseChannelOptions();
    if (channelMode === 'poll' && options.length < 2) {
      toast.error(i18n.t("messagesAPI.messages.pollOptionsError"));
      return;
    }

    const data = new FormData();
    data.append('newsletterJid', channelJid);

    if (channelMode === 'poll') {
      data.append('type', 'poll');
      data.append('question', channelBody);
      data.append('options', JSON.stringify(options));
      data.append('selectableCount', channelSelectableCount);
    } else {
      data.append('body', channelBody);
      if (channelMode === 'media' && channelMedia) {
        data.append('medias', channelMedia);
      }
    }

    setIsSubmittingChannel(true);
    try {
      const { data: response } = await axios.post(getNewsletterEndpoint(), data, {
        headers: {
          'Content-type': 'multipart/form-data',
          'Authorization': `Bearer ${channelToken}`
        }
      });

      if (response?.success) {
        toast.success(i18n.t("messagesAPI.messages.successChannel"));
      } else {
        toast.warn(response?.message || i18n.t("messagesAPI.messages.channelNotVerified"));
      }
    } catch (err) {
      toastError(err);
    } finally {
      setIsSubmittingChannel(false);
    }
  }

  const renderFormMessageText = () => {
    return (
      <div className={classes.formContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label={i18n.t("messagesAPI.forms.tokenRegistered")}
              value={textToken}
              onChange={(e) => {
                console.log('🔍 DEBUG Simple - Token cambiado:', e.target.value);
                setTextToken(e.target.value);
              }}
              autoFocus
              variant="outlined"
              margin="dense"
              fullWidth
              className={classes.textField}
              required
              placeholder={i18n.t("messagesAPI.forms.tokenPlaceholder")}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label={i18n.t("messagesAPI.forms.number")}
              value={textNumber}
              onChange={(e) => setTextNumber(e.target.value)}
              variant="outlined"
              margin="dense"
              fullWidth
              className={classes.textField}
              required
              placeholder={i18n.t("messagesAPI.forms.numberPlaceholder")}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label={i18n.t("messagesAPI.forms.message")}
              value={textBody}
              onChange={(e) => setTextBody(e.target.value)}
              variant="outlined"
              margin="dense"
              fullWidth
              multiline
              rows={3}
              className={classes.textField}
              required
              placeholder={i18n.t("messagesAPI.forms.messagePlaceholder")}
            />
          </Grid>
          <Grid item xs={12} className={classes.textRight}>
            <Button
              onClick={handleSendTextMessageSimple}
              color="primary"
              variant="contained"
              startIcon={<SendIcon />}
              className={classes.btnWrapper}
              disabled={isSubmittingText || !textToken || !textNumber || !textBody}
            >
              {isSubmittingText ? (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              ) : i18n.t("messagesAPI.forms.sendMessage")}
            </Button>
          </Grid>
        </Grid>
      </div>
    )
  }

  const renderFormMessageMedia = () => {
    return (
      <div className={classes.formContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label={i18n.t("messagesAPI.forms.tokenRegistered")}
              value={mediaToken}
              onChange={(e) => {
                console.log('🔍 DEBUG Media Simple - Token cambiado:', e.target.value);
                setMediaToken(e.target.value);
              }}
              variant="outlined"
              margin="dense"
              fullWidth
              className={classes.textField}
              required
              placeholder={i18n.t("messagesAPI.forms.tokenPlaceholder")}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label={i18n.t("messagesAPI.forms.number")}
              value={mediaNumber}
              onChange={(e) => setMediaNumber(e.target.value)}
              variant="outlined"
              margin="dense"
              fullWidth
              className={classes.textField}
              required
              placeholder={i18n.t("messagesAPI.forms.numberPlaceholder")}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label={i18n.t("messagesAPI.forms.messageOptional")}
              value={mediaBody}
              onChange={(e) => setMediaBody(e.target.value)}
              variant="outlined"
              margin="dense"
              fullWidth
              multiline
              rows={2}
              className={classes.textField}
              placeholder={i18n.t("messagesAPI.forms.messageOptionalPlaceholder")}
            />
          </Grid>
          <Grid item xs={12}>
            <div className={classes.fileUploadArea} onClick={() => document.getElementById('medias').click()}>
              <CloudUploadIcon style={{ fontSize: 48, color: theme.palette.primary.main, marginBottom: 16 }} />
              <Typography variant="h6" gutterBottom style={{ color: theme.palette.text.primary }}>
                {selectedFileName ? selectedFileName : i18n.t("messagesAPI.forms.selectFile")}
              </Typography>
              <Typography variant="body2" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                {i18n.t("messagesAPI.forms.clickUploadHint")}
              </Typography>
              {file[0] && (
                <div className={classes.fileInfo}>
                  <strong>{i18n.t("messagesAPI.forms.fileSize")}</strong> {formatFileSize(file[0].size)}
                </div>
              )}
              <input 
                type="file" 
                name="medias" 
                id="medias" 
                required 
                onChange={handleFileChange}
                style={{ display: 'none' }}
                accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
              />
            </div>
          </Grid>
          <Grid item xs={12} className={classes.textRight}>
            <Button
              onClick={handleSendMediaMessageSimple}
              color="primary"
              variant="contained"
              startIcon={<AttachFileIcon />}
              className={classes.btnWrapper}
              disabled={isSubmittingMedia || !mediaToken || !mediaNumber || !file[0]}
            >
              {isSubmittingMedia ? (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              ) : i18n.t("messagesAPI.forms.sendMedia")}
            </Button>
          </Grid>
        </Grid>
      </div>
    )
  }

  const statusEndpoint = () => getEndpoint().replace(/\/send$/, "/send-status");
  const sendStatusTest = async () => {
    const formData = new FormData();
    formData.append("name", "Prueba desde Chats / API");
    formData.append("targetType", statusTarget);
    formData.append("body", statusBody);
    if (statusTarget === "contacts") formData.append("contactIds", statusContacts);
    if (statusMedia) formData.append("media", statusMedia);
    setIsSubmittingStatus(true);
    try {
      const { data } = await axios.post(statusEndpoint(), formData, {
        headers: { Authorization: `Bearer ${statusToken}` }
      });
      if (data?.success === false) {
        toast.error(data?.message || i18n.t("messagesAPI.sectionStatus.testNote"));
        return;
      }
      toast.success(i18n.t("messagesAPI.sectionStatus.title"));
      setStatusBody("");
      setStatusMedia(null);
    } catch (err) {
      toastError(err);
    } finally {
      setIsSubmittingStatus(false);
    }
  };

  const externalApiBase = getExternalApiBase();

  return (
    <Paper className={classes.mainPaper} variant="outlined">
      <Typography variant="h4" className={classes.mainHeader}>
        <MessageIcon style={{ marginRight: 16, verticalAlign: 'middle' }} />
        {i18n.t("messagesAPI.title")}
        <GuideOpenButton id="api" title={i18n.t("messagesAPI.title")} to="/messages-api" startId="token" />
      </Typography>

      {/* Información General */}
      <Alert severity="info" className={classes.elementMargin}>
        <Typography variant="h6" gutterBottom>
          <InfoIcon style={{ marginRight: 8, verticalAlign: 'middle' }} />
          {i18n.t("messagesAPI.importantInfo.title")}
        </Typography>
        <ul>
          <li><strong>{i18n.t("messagesAPI.importantInfo.tokenLabel")}:</strong> {i18n.t("messagesAPI.importantInfo.tokenBody")}</li>
          <li><strong>{i18n.t("messagesAPI.importantInfo.formatLabel")}:</strong> {i18n.t("messagesAPI.importantInfo.formatBody")}</li>
          <li><strong>{i18n.t("messagesAPI.importantInfo.exampleLabel")}:</strong> {i18n.t("messagesAPI.importantInfo.exampleBody")}</li>
          <li><strong>{i18n.t("messagesAPI.importantInfo.channelsLabel")}:</strong> {i18n.t("messagesAPI.importantInfo.channelsBody")}</li>
        </ul>
      </Alert>

      {/* Sección 1: Mensajes de Texto */}
      <Card className={classes.sectionCard}>
        <CardHeader 
          className={classes.sectionHeader}
          title={
            <Box display="flex" alignItems="center">
              <MessageIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">{i18n.t("messagesAPI.section1.title")}</Typography>
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                {i18n.t("messagesAPI.common.apiInfoTitle")}
              </Typography>
              <Typography component="div" style={{ color: theme.palette.text.primary }}>
                <p>{i18n.t("messagesAPI.section1.intro")}</p>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.endpoint")} className={classes.endpointBox} />
                </Box>
                <div className={classes.endpointBox}>
                  {getEndpoint()}
                </div>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.method")} className={classes.methodChip} />
                  <Typography style={{ marginLeft: 8, color: theme.palette.text.primary }}>POST</Typography>
                </Box>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.headers")} className={classes.headerChip} />
                  <Typography style={{ marginLeft: 8, color: theme.palette.text.primary }}>{i18n.t("messagesAPI.apiInfo.authorization")}</Typography>
                </Box>
                
                <Typography variant="subtitle2" gutterBottom style={{ color: theme.palette.text.primary }}>
                  <strong>{i18n.t("messagesAPI.common.bodyJson")}</strong>
                </Typography>
                <div className={classes.endpointBox}>
                  {i18n.t("messagesAPI.section1.bodySnippet")}
                </div>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                {i18n.t("messagesAPI.common.testSendTitle")}
              </Typography>
              {renderFormMessageText()}
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Sección 2: Mensajes Multimedia */}
      <Card className={classes.sectionCard}>
        <CardHeader 
          className={classes.sectionHeader}
          title={
            <Box display="flex" alignItems="center">
              <AttachFileIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">{i18n.t("messagesAPI.section2.title")}</Typography>
              <Chip label={i18n.t("messagesAPI.chips.upTo100mb")} className={classes.limitChip} style={{ marginLeft: 16 }} />
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                {i18n.t("messagesAPI.common.apiInfoTitle")}
              </Typography>
              <Typography component="div">
                <p>{i18n.t("messagesAPI.section2.intro")}</p>
                
                <Alert severity="success" style={{ marginBottom: 16 }}>
                  <strong><span role="img" aria-label="checkmark">✅</span> {i18n.t("messagesAPI.section2.maxCapacity")}</strong> {i18n.t("messagesAPI.section2.maxCapacityBody")}
                </Alert>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.endpoint")} className={classes.endpointBox} />
                </Box>
                <div className={classes.endpointBox}>
                  {getEndpoint()}
                </div>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.method")} className={classes.methodChip} />
                  <Typography style={{ marginLeft: 8, color: theme.palette.text.primary }}>POST</Typography>
                </Box>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.headers")} className={classes.headerChip} />
                  <Typography style={{ marginLeft: 8 }}>{i18n.t("messagesAPI.apiInfo.multipartForm")}</Typography>
                </Box>
                
                <Typography variant="subtitle2" gutterBottom style={{ color: theme.palette.text.primary }}>
                  <strong>{i18n.t("messagesAPI.common.formData")}</strong>
                </Typography>
                <ul>
                  <li><strong>{i18n.t("messagesAPI.section2.formDataNumber")}</strong> {i18n.t("messagesAPI.section2.formDataNumberEx")}</li>
                  <li><strong>{i18n.t("messagesAPI.section2.formDataMedias")}</strong> {i18n.t("messagesAPI.section2.formDataMediasEx")}</li>
                  <li><strong>{i18n.t("messagesAPI.section2.formDataBody")}</strong> {i18n.t("messagesAPI.section2.formDataBodyEx")}</li>
                </ul>
                
                <Typography variant="subtitle2" gutterBottom style={{ marginTop: 16, color: theme.palette.text.primary }}>
                  <strong>{i18n.t("messagesAPI.section2.fileTypesTitle")}</strong>
                </Typography>
                <ul>
                  <li><strong>{i18n.t("messagesAPI.section2.images")}</strong> {i18n.t("messagesAPI.section2.imagesEx")}</li>
                  <li><strong>{i18n.t("messagesAPI.section2.videos")}</strong> {i18n.t("messagesAPI.section2.videosEx")}</li>
                  <li><strong>{i18n.t("messagesAPI.section2.documents")}</strong> {i18n.t("messagesAPI.section2.documentsEx")}</li>
                  <li><strong>{i18n.t("messagesAPI.section2.audio")}</strong> {i18n.t("messagesAPI.section2.audioEx")}</li>
                </ul>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                {i18n.t("messagesAPI.common.testSendTitle")}
              </Typography>
              {renderFormMessageMedia()}
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Sección 3: Mensajes a Grupos */}
      <Card className={classes.sectionCard}>
        <CardHeader 
          className={classes.sectionHeader}
          title={
            <Box display="flex" alignItems="center">
              <MessageIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">{i18n.t("messagesAPI.section3.title")}</Typography>
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                {i18n.t("messagesAPI.common.apiInfoTitle")}
              </Typography>
              <Typography component="div" style={{ color: theme.palette.text.primary }}>
                <p>{i18n.t("messagesAPI.section3.intro")}</p>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.endpoint")} className={classes.endpointBox} />
                </Box>
                <div className={classes.endpointBox}>
                  {getEndpoint() + '/send-group/:whatsappId'}
                </div>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.method")} className={classes.methodChip} />
                  <Typography style={{ marginLeft: 8, color: theme.palette.text.primary }}>POST</Typography>
                </Box>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.headers")} className={classes.headerChip} />
                  <Typography style={{ marginLeft: 8, color: theme.palette.text.primary }}>{i18n.t("messagesAPI.apiInfo.authorization")}</Typography>
                </Box>
                
                <Typography variant="subtitle2" gutterBottom style={{ color: theme.palette.text.primary }}>
                  <strong>{i18n.t("messagesAPI.common.bodyJson")}</strong>
                </Typography>
                <div className={classes.endpointBox}>
                  {i18n.t("messagesAPI.section3.bodySnippet")}
                </div>

                <Alert severity="warning" style={{ marginTop: 16 }}>
                  <strong><span role="img" aria-label="warning">⚠️</span> {i18n.t("messagesAPI.section3.groupNote")}</strong> {i18n.t("messagesAPI.section3.groupNoteBody")}
                </Alert>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                {i18n.t("messagesAPI.common.testSendTitle")}
              </Typography>
              <div className={classes.formContainer}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.tokenRegisteredReq")}
                      value={groupToken}
                      onChange={(e) => setGroupToken(e.target.value)}
                      autoFocus
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      placeholder={i18n.t("messagesAPI.forms.tokenPlaceholder")}
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.groupId")}
                      value={groupId}
                      onChange={(e) => setGroupId(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      placeholder="12036312345678901234"
                      helperText={i18n.t("messagesAPI.forms.groupIdHelper")}
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.messageReq")}
                      value={groupBody}
                      onChange={(e) => setGroupBody(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      multiline
                      rows={3}
                      required
                      placeholder={i18n.t("messagesAPI.forms.messagePlaceholder")}
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.textRight}>
                    <Button
                      onClick={handleSendGroupMessage}
                      color="primary"
                      variant="contained"
                      startIcon={<SendIcon />}
                      className={classes.btnWrapper}
                      disabled={isSubmittingGroup || !groupToken || !groupId || !groupBody}
                    >
                      {isSubmittingGroup ? (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      ) : i18n.t("messagesAPI.forms.sendToGroup")}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Sección 4: Mensajes Multimedia a Grupos */}
      <Card className={classes.sectionCard}>
        <CardHeader 
          className={classes.sectionHeader}
          title={
            <Box display="flex" alignItems="center">
              <AttachFileIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">{i18n.t("messagesAPI.section4.title")}</Typography>
              <Chip label={i18n.t("messagesAPI.chips.upTo100mb")} className={classes.limitChip} style={{ marginLeft: 16 }} />
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                {i18n.t("messagesAPI.common.apiInfoTitle")}
              </Typography>
              <Typography component="div" style={{ color: theme.palette.text.primary }}>
                <p>{i18n.t("messagesAPI.section4.intro")}</p>
                
                <Alert severity="success" style={{ marginBottom: 16 }}>
                  <strong><span role="img" aria-label="checkmark">✅</span> {i18n.t("messagesAPI.section2.maxCapacity")}</strong> {i18n.t("messagesAPI.section2.maxCapacityBody")}
                </Alert>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.endpoint")} className={classes.endpointBox} />
                </Box>
                <div className={classes.endpointBox}>
                  {getEndpoint() + '/send-group/:whatsappId'}
                </div>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.method")} className={classes.methodChip} />
                  <Typography style={{ marginLeft: 8, color: theme.palette.text.primary }}>POST</Typography>
                </Box>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.headers")} className={classes.headerChip} />
                  <Typography style={{ marginLeft: 8 }}>{i18n.t("messagesAPI.apiInfo.multipartForm")}</Typography>
                </Box>
                
                <Typography variant="subtitle2" gutterBottom style={{ color: theme.palette.text.primary }}>
                  <strong>{i18n.t("messagesAPI.common.formData")}</strong>
                </Typography>
                <ul>
                  <li><strong>{i18n.t("messagesAPI.section2.formDataNumber")}</strong> {i18n.t("messagesAPI.section4.formDataNumberLi")}</li>
                  <li><strong>{i18n.t("messagesAPI.section2.formDataMedias")}</strong> {i18n.t("messagesAPI.section4.formDataMediasLi")}</li>
                  <li><strong>{i18n.t("messagesAPI.section2.formDataBody")}</strong> {i18n.t("messagesAPI.section2.formDataBodyEx")}</li>
                </ul>
                
                <Typography variant="subtitle2" gutterBottom style={{ marginTop: 16, color: theme.palette.text.primary }}>
                  <strong>{i18n.t("messagesAPI.section2.fileTypesTitle")}</strong>
                </Typography>
                <ul>
                  <li><strong>{i18n.t("messagesAPI.section2.images")}</strong> {i18n.t("messagesAPI.section2.imagesEx")}</li>
                  <li><strong>{i18n.t("messagesAPI.section2.videos")}</strong> {i18n.t("messagesAPI.section2.videosEx")}</li>
                  <li><strong>{i18n.t("messagesAPI.section2.documents")}</strong> {i18n.t("messagesAPI.section2.documentsEx")}</li>
                  <li><strong>{i18n.t("messagesAPI.section2.audio")}</strong> {i18n.t("messagesAPI.section2.audioEx")}</li>
                </ul>

                <Alert severity="warning" style={{ marginTop: 16 }}>
                  <strong><span role="img" aria-label="warning">⚠️</span> {i18n.t("messagesAPI.section3.groupNote")}</strong> {i18n.t("messagesAPI.section3.groupNoteBody")}
                </Alert>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                {i18n.t("messagesAPI.common.testSendTitle")}
              </Typography>
              <div className={classes.formContainer}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.tokenRegisteredReq")}
                      value={groupMediaToken}
                      onChange={(e) => setGroupMediaToken(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      placeholder={i18n.t("messagesAPI.forms.tokenPlaceholder")}
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.groupId")}
                      value={groupMediaId}
                      onChange={(e) => setGroupMediaId(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      placeholder="12036312345678901234"
                      helperText={i18n.t("messagesAPI.forms.groupIdHelperShort")}
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.messageOptional")}
                      value={groupMediaBody}
                      onChange={(e) => setGroupMediaBody(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      multiline
                      rows={2}
                      placeholder={i18n.t("messagesAPI.forms.messageOptionalPlaceholder")}
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <div className={classes.fileUploadArea} onClick={() => document.getElementById('groupMedias').click()}>
                      <CloudUploadIcon style={{ fontSize: 48, color: theme.palette.primary.main, marginBottom: 16 }} />
                      <Typography variant="h6" gutterBottom style={{ color: theme.palette.text.primary }}>
                        {groupMediaFileName ? groupMediaFileName : i18n.t("messagesAPI.forms.selectFile")}
                      </Typography>
                      <Typography variant="body2" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                        {i18n.t("messagesAPI.forms.clickUploadHint")}
                      </Typography>
                      {groupMediaFile[0] && (
                        <div className={classes.fileInfo}>
                          <strong>{i18n.t("messagesAPI.forms.fileSize")}</strong> {formatFileSize(groupMediaFile[0].size)}
                        </div>
                      )}
                      <input 
                        type="file" 
                        name="medias" 
                        id="groupMedias" 
                        required 
                        onChange={handleGroupMediaFileChange}
                        style={{ display: 'none' }}
                        accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} className={classes.textRight}>
                    <Button
                      onClick={handleSendGroupMedia}
                      color="primary"
                      variant="contained"
                      startIcon={<AttachFileIcon />}
                      className={classes.btnWrapper}
                      disabled={isSubmittingGroupMedia || !groupMediaToken || !groupMediaId || !groupMediaFile[0]}
                    >
                      {isSubmittingGroupMedia ? (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      ) : i18n.t("messagesAPI.forms.sendMediaToGroup")}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Sección 5: Canales WhatsApp */}
      <Card className={classes.sectionCard}>
        <CardHeader
          className={classes.sectionHeader}
          title={
            <Box display="flex" alignItems="center">
              <AnnouncementIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">{i18n.t("messagesAPI.sectionChannel.title")}</Typography>
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                {i18n.t("messagesAPI.common.apiInfoTitle")}
              </Typography>
              <Typography component="div" style={{ color: theme.palette.text.primary }}>
                <p>{i18n.t("messagesAPI.sectionChannel.intro")}</p>
                <div className={classes.endpointBox}>
                  {`${getEndpoint().replace(/\/send$/, '')}/send-newsletter/:whatsappId`}
                </div>
                <p><strong>{i18n.t("messagesAPI.sectionChannel.destinationTitle")}</strong> {i18n.t("messagesAPI.sectionChannel.destinationBody")}</p>
                <p><strong>{i18n.t("messagesAPI.sectionChannel.securityTitle")}</strong> {i18n.t("messagesAPI.sectionChannel.securityBody")}</p>

                <Typography variant="subtitle2"><strong>{i18n.t("messagesAPI.sectionChannel.textTitle")}</strong></Typography>
                <div className={classes.endpointBox} style={{ whiteSpace: 'pre-wrap' }}>
                  {i18n.t("messagesAPI.sectionChannel.textCurl", {
                    endpoint: `${getEndpoint().replace(/\/send$/, '')}/send-newsletter/1`
                  })}
                </div>

                <Typography variant="subtitle2" style={{ marginTop: 16 }}><strong>{i18n.t("messagesAPI.sectionChannel.mediaTitle")}</strong></Typography>
                <div className={classes.endpointBox} style={{ whiteSpace: 'pre-wrap' }}>
                  {i18n.t("messagesAPI.sectionChannel.mediaCurl", {
                    endpoint: `${getEndpoint().replace(/\/send$/, '')}/send-newsletter/1`
                  })}
                </div>

                <Typography variant="subtitle2" style={{ marginTop: 16 }}><strong>{i18n.t("messagesAPI.sectionChannel.pollTitle")}</strong></Typography>
                <div className={classes.endpointBox} style={{ whiteSpace: 'pre-wrap' }}>
                  {i18n.t("messagesAPI.sectionChannel.pollCurl", {
                    endpoint: `${getEndpoint().replace(/\/send$/, '')}/send-newsletter/1`
                  })}
                </div>

                <Alert severity="info" style={{ marginTop: 16 }}>
                  {i18n.t("messagesAPI.sectionChannel.responseNote")}
                </Alert>
                <Alert severity="warning" style={{ marginTop: 16 }}>
                  {i18n.t("messagesAPI.sectionChannel.limitsNote")}
                </Alert>
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                {i18n.t("messagesAPI.common.testSendTitle")}
              </Typography>
              <div className={classes.formContainer}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.tokenRegisteredReq")}
                      value={channelToken}
                      onChange={(e) => setChannelToken(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.whatsappId")}
                      value={channelWhatsappId}
                      onChange={(e) => setChannelWhatsappId(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.channelJid")}
                      value={channelJid}
                      onChange={(e) => setChannelJid(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      placeholder="123456789@newsletter"
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      select
                      SelectProps={{ native: true }}
                      label={i18n.t("messagesAPI.forms.channelMode")}
                      value={channelMode}
                      onChange={(e) => setChannelMode(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.textField}
                    >
                      <option value="text">{i18n.t("messagesAPI.forms.channelText")}</option>
                      <option value="media">{i18n.t("messagesAPI.forms.channelMedia")}</option>
                      <option value="poll">{i18n.t("messagesAPI.forms.channelPoll")}</option>
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={
                        channelMode === 'poll'
                          ? i18n.t("messagesAPI.forms.pollQuestion")
                          : i18n.t("messagesAPI.forms.message")
                      }
                      value={channelBody}
                      onChange={(e) => setChannelBody(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      multiline
                      rows={3}
                      required={channelMode !== 'media'}
                      className={classes.textField}
                    />
                  </Grid>
                  {channelMode === 'media' && (
                    <Grid item xs={12}>
                      <input
                        type="file"
                        onChange={(e) => setChannelMedia(e.target.files?.[0] || null)}
                        accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                      />
                    </Grid>
                  )}
                  {channelMode === 'poll' && (
                    <>
                      <Grid item xs={12}>
                        <TextField
                          label={i18n.t("messagesAPI.forms.pollOptions")}
                          value={channelOptions}
                          onChange={(e) => setChannelOptions(e.target.value)}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          multiline
                          rows={4}
                          helperText={i18n.t("messagesAPI.forms.pollOptionsHelper")}
                          className={classes.textField}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          select
                          SelectProps={{ native: true }}
                          label={i18n.t("messagesAPI.forms.pollSelectionMode")}
                          value={channelSelectableCount}
                          onChange={(e) => setChannelSelectableCount(e.target.value)}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          className={classes.textField}
                        >
                          <option value="1">{i18n.t("messagesAPI.forms.pollSingleChoice")}</option>
                          <option value="0">{i18n.t("messagesAPI.forms.pollMultipleChoice")}</option>
                        </TextField>
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} className={classes.textRight}>
                    <Button
                      onClick={handleSendChannel}
                      color="primary"
                      variant="contained"
                      startIcon={<AnnouncementIcon />}
                      disabled={
                        isSubmittingChannel ||
                        !channelToken ||
                        !channelWhatsappId ||
                        !channelJid ||
                        (channelMode === 'text' && !channelBody) ||
                        (channelMode === 'media' && !channelMedia) ||
                        (channelMode === 'poll' && (!channelBody || parseChannelOptions().length < 2))
                      }
                    >
                      {isSubmittingChannel
                        ? <CircularProgress size={24} className={classes.buttonProgress} />
                        : i18n.t("messagesAPI.forms.sendChannel")}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card className={classes.sectionCard} id="estados">
        <CardHeader
          className={classes.sectionHeader}
          title={
            <Box display="flex" alignItems="center">
              <CameraAltOutlinedIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">{i18n.t("messagesAPI.sectionStatus.title")}</Typography>
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">{i18n.t("messagesAPI.common.apiInfoTitle")}</Typography>
              <Typography component="div" style={{ color: theme.palette.text.primary }}>
                <p>{i18n.t("messagesAPI.sectionStatus.intro")}</p>
                <div className={classes.endpointBox}>{statusEndpoint()}</div>
                <p><strong>{i18n.t("messagesAPI.sectionStatus.whatsappTitle")}:</strong> {i18n.t("messagesAPI.sectionStatus.whatsappBody")}</p>
                <p><strong>{i18n.t("messagesAPI.sectionStatus.telegramTitle")}:</strong> {i18n.t("messagesAPI.sectionStatus.telegramBody")}</p>
                <p><strong>{i18n.t("messagesAPI.sectionStatus.fieldsTitle")}:</strong> {i18n.t("messagesAPI.sectionStatus.fieldsBody")}</p>
                <div className={classes.endpointBox} style={{ whiteSpace: "pre-wrap" }}>
                  {i18n.t("messagesAPI.sectionStatus.curl", { endpoint: statusEndpoint() })}
                </div>
                <p>{i18n.t("messagesAPI.sectionStatus.resultBody", { endpoint: statusEndpoint() })}</p>
                <Alert severity="info" style={{ marginTop: 16 }}>{i18n.t("messagesAPI.sectionStatus.testNote")}</Alert>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">{i18n.t("messagesAPI.common.testSendTitle")}</Typography>
              <div className={classes.formContainer}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField label={i18n.t("messagesAPI.forms.tokenRegisteredReq")} value={statusToken} onChange={e => setStatusToken(e.target.value)} variant="outlined" margin="dense" fullWidth required className={classes.textField} />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField select SelectProps={{ native: true }} label="targetType" value={statusTarget} onChange={e => setStatusTarget(e.target.value)} variant="outlined" margin="dense" fullWidth className={classes.textField}>
                      <option value="all">all</option>
                      <option value="contacts">contacts</option>
                    </TextField>
                  </Grid>
                  {statusTarget === "contacts" && (
                    <Grid item xs={12}>
                      <TextField label="contactIds" value={statusContacts} onChange={e => setStatusContacts(e.target.value)} variant="outlined" margin="dense" fullWidth placeholder="1,2,3" className={classes.textField} />
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <TextField label={i18n.t("messagesAPI.forms.message")} value={statusBody} onChange={e => setStatusBody(e.target.value)} variant="outlined" margin="dense" fullWidth multiline rows={3} className={classes.textField} />
                  </Grid>
                  <Grid item xs={12}>
                    <input type="file" accept="image/*,video/*,audio/*" onChange={e => setStatusMedia(e.target.files?.[0] || null)} />
                  </Grid>
                  <Grid item xs={12} className={classes.textRight}>
                    <Button color="primary" variant="contained" startIcon={<CameraAltOutlinedIcon />} onClick={sendStatusTest} disabled={isSubmittingStatus || !statusToken || (!statusBody && !statusMedia) || (statusTarget === "contacts" && !statusContacts)}>
                      {isSubmittingStatus ? <CircularProgress size={24} className={classes.buttonProgress} /> : i18n.t("messagesAPI.sectionStatus.title")}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Sección 6: Encuestas, preguntas y cuestionarios */}
      <Card className={classes.sectionCard}>
        <CardHeader
          className={classes.sectionHeader}
          title={
            <Box display="flex" alignItems="center">
              <PollIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">{i18n.t("messagesAPI.sectionPoll.title")}</Typography>
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                {i18n.t("messagesAPI.common.apiInfoTitle")}
              </Typography>
              <Typography component="div" style={{ color: theme.palette.text.primary }}>
                <p>{i18n.t("messagesAPI.sectionPoll.intro")}</p>

                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.endpoint")} className={classes.endpointBox} />
                </Box>
                <div className={classes.endpointBox}>{getEndpoint()}</div>

                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.method")} className={classes.methodChip} />
                  <Typography style={{ marginLeft: 8 }}>POST</Typography>
                </Box>

                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label={i18n.t("messagesAPI.chips.headers")} className={classes.headerChip} />
                  <Typography style={{ marginLeft: 8 }}>{i18n.t("messagesAPI.apiInfo.authorization")}</Typography>
                </Box>

                <Typography variant="subtitle2" gutterBottom>
                  <strong>{i18n.t("messagesAPI.common.bodyJson")}</strong>
                </Typography>
                <div className={classes.endpointBox} style={{ whiteSpace: 'pre-wrap' }}>
                  {i18n.t("messagesAPI.sectionPoll.bodySnippet")}
                </div>

                <Typography variant="subtitle2" gutterBottom style={{ marginTop: 16 }}>
                  <strong>{i18n.t("messagesAPI.sectionPoll.fieldsTitle")}</strong>
                </Typography>
                <ul>
                  <li><strong>type:</strong> {i18n.t("messagesAPI.sectionPoll.typeField")}</li>
                  <li><strong>number:</strong> {i18n.t("messagesAPI.sectionPoll.numberField")}</li>
                  <li><strong>question/body:</strong> {i18n.t("messagesAPI.sectionPoll.questionField")}</li>
                  <li><strong>options/values:</strong> {i18n.t("messagesAPI.sectionPoll.optionsField")}</li>
                  <li><strong>selectableCount:</strong> {i18n.t("messagesAPI.sectionPoll.selectableCountField")}</li>
                </ul>

                <Alert severity="info" style={{ marginTop: 16 }}>
                  {i18n.t("messagesAPI.sectionPoll.quizNote")}
                </Alert>

                <Typography variant="subtitle2" gutterBottom style={{ marginTop: 16 }}>
                  <strong>cURL:</strong>
                </Typography>
                <div className={classes.endpointBox} style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                  {`curl -X POST "${getEndpoint()}" \\
  -H "Authorization: Bearer TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{"type":"poll","number":"51959858768","question":"¿Qué horario prefieres?","options":["Mañana","Tarde","Noche"],"selectableCount":1}'`}
                </div>

                <Alert severity="warning" style={{ marginTop: 16 }}>
                  {i18n.t("messagesAPI.sectionPoll.validationNote")}
                </Alert>
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                {i18n.t("messagesAPI.common.testSendTitle")}
              </Typography>
              <div className={classes.formContainer}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.tokenRegisteredReq")}
                      value={pollToken}
                      onChange={(e) => setPollToken(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      placeholder={i18n.t("messagesAPI.forms.tokenPlaceholder")}
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.numberReq")}
                      value={pollNumber}
                      onChange={(e) => setPollNumber(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      placeholder={i18n.t("messagesAPI.forms.numberPlaceholder")}
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.pollQuestion")}
                      value={pollQuestion}
                      onChange={(e) => setPollQuestion(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label={i18n.t("messagesAPI.forms.pollOptions")}
                      value={pollOptions}
                      onChange={(e) => setPollOptions(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      multiline
                      rows={5}
                      required
                      helperText={i18n.t("messagesAPI.forms.pollOptionsHelper")}
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      select
                      SelectProps={{ native: true }}
                      label={i18n.t("messagesAPI.forms.pollSelectionMode")}
                      value={pollSelectableCount}
                      onChange={(e) => setPollSelectableCount(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.textField}
                    >
                      <option value="1">{i18n.t("messagesAPI.forms.pollSingleChoice")}</option>
                      <option value="0">{i18n.t("messagesAPI.forms.pollMultipleChoice")}</option>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} className={classes.textRight}>
                    <Button
                      onClick={handleSendPoll}
                      color="primary"
                      variant="contained"
                      startIcon={<PollIcon />}
                      className={classes.btnWrapper}
                      disabled={
                        isSubmittingPoll ||
                        !pollToken ||
                        !pollNumber ||
                        !pollQuestion ||
                        parsePollOptions().length < 2
                      }
                    >
                      {isSubmittingPoll ? (
                        <CircularProgress size={24} className={classes.buttonProgress} />
                      ) : i18n.t("messagesAPI.forms.sendPoll")}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Sección 7: API Externa (N8N / TypeBot) */}
      <Card className={classes.sectionCard}>
        <CardHeader 
          className={classes.sectionHeader}
          title={
            <Box display="flex" alignItems="center">
              <CodeIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">{i18n.t("messagesAPI.section5.title")}</Typography>
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Alert severity="info" style={{ marginBottom: 16 }}>
                <Typography variant="body2">
                  {i18n.t("messagesAPI.section5.intro")}
                </Typography>
              </Alert>
              <Typography variant="subtitle2" gutterBottom style={{ color: theme.palette.text.primary }}>
                <strong>{i18n.t("messagesAPI.section5.baseUrl")}</strong>
              </Typography>
              <div className={classes.endpointBox}>
                {externalApiBase}
              </div>
              <Typography variant="subtitle2" gutterBottom style={{ marginTop: 16, color: theme.palette.text.primary }}>
                <strong>{i18n.t("messagesAPI.section5.headersLine")}</strong> <code>Authorization: Bearer {'{'}token{'}'}</code>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">{i18n.t("messagesAPI.section5.getTicketByNumber")}</Typography>
              <div className={classes.endpointBox}>
                {`${externalApiBase}/ticket?number=51980795334`}
              </div>
              <Typography variant="body2" style={{ marginTop: 8, color: theme.palette.text.secondary }}>
                curl: <code>curl -H &quot;Authorization: Bearer TOKEN&quot; &quot;{externalApiBase}/ticket?number=51980795334&quot;</code>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">{i18n.t("messagesAPI.section5.getTicketById")}</Typography>
              <div className={classes.endpointBox}>
                {`${externalApiBase}/ticket/:ticketId`}
              </div>
              <Typography variant="body2" style={{ marginTop: 8, color: theme.palette.text.secondary }}>
                curl: <code>curl -H &quot;Authorization: Bearer TOKEN&quot; &quot;{externalApiBase}/ticket/123&quot;</code>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">{i18n.t("messagesAPI.section5.getUsers")}</Typography>
              <div className={classes.endpointBox}>
                {`${externalApiBase}/users`}
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">{i18n.t("messagesAPI.section5.getTags")}</Typography>
              <div className={classes.endpointBox}>
                {`${externalApiBase}/tags`}
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">{i18n.t("messagesAPI.section5.putAssignTag")}</Typography>
              <div className={classes.endpointBox}>
                {`${externalApiBase}/ticket/:ticketId/tag`}
              </div>
              <Typography variant="body2" style={{ marginTop: 8, color: theme.palette.text.secondary }}>
                {i18n.t("messagesAPI.section5.bodyLabel")} <code>{`{ "tagId": 1 }`}</code>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">{i18n.t("messagesAPI.section5.putUpdateTicket")}</Typography>
              <div className={classes.endpointBox}>
                {`${externalApiBase}/ticket/:ticketId`}
              </div>
              <Typography variant="body2" style={{ marginTop: 8, color: theme.palette.text.secondary }}>
                {i18n.t("messagesAPI.section5.bodyLabel")} <code>{`{ "status": "open", "userId": 1, "queueId": 2 }`}</code>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom style={{ color: theme.palette.text.primary }}>
                <strong>{i18n.t("messagesAPI.section5.altPostTitle")}</strong>
              </Typography>
              <Typography variant="body2" style={{ marginBottom: 8, color: theme.palette.text.secondary }}>
                {i18n.t("messagesAPI.section5.postTicketBody1", { base: externalApiBase })}
              </Typography>
              <Typography variant="body2" style={{ marginBottom: 8, color: theme.palette.text.secondary }}>
                {i18n.t("messagesAPI.section5.postTicketBody2", { base: externalApiBase, telefono: "{{telefono}}" })}
              </Typography>
              <Typography variant="body2" style={{ marginBottom: 8, color: theme.palette.text.secondary }}>
                {i18n.t("messagesAPI.section5.postTicketBody3", { base: externalApiBase, atendimento: "{{atendimento}}" })}
              </Typography>
              <Typography variant="body2" style={{ marginBottom: 8, color: theme.palette.text.secondary }}>
                {i18n.t("messagesAPI.section5.postTicketBody4", { base: externalApiBase })}
              </Typography>
              <Typography variant="body2" style={{ color: theme.palette.text.secondary }}>
                {i18n.t("messagesAPI.section5.postUsersTags", { base: externalApiBase })}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom style={{ color: theme.palette.text.primary }}>
                <strong>{i18n.t("messagesAPI.section5.variablesObjectTitle")}</strong>
              </Typography>
              <div className={classes.endpointBox} style={{ fontSize: '0.8rem' }}>
                {i18n.t("messagesAPI.section5.variablesList")}
              </div>
            </Grid>
            <Grid item xs={12}>
              <Alert severity="success" style={{ marginTop: 16 }}>
                <Typography variant="subtitle2" gutterBottom><strong>{i18n.t("messagesAPI.section5.typebotGuideTitle")}</strong></Typography>
                <Typography variant="body2" component="div">
                  <ol style={{ margin: 0, paddingLeft: 20 }}>
                    <li>{i18n.t("messagesAPI.section5.typebotStep1")}</li>
                    <li>{i18n.t("messagesAPI.section5.typebotStep2", { telefono: "{{telefono}}" })}</li>
                    <li>{i18n.t("messagesAPI.section5.typebotStep3")}</li>
                    <li>{i18n.t("messagesAPI.section5.typebotStep4")}</li>
                    <li>{i18n.t("messagesAPI.section5.typebotStep5")}</li>
                  </ol>
                  <Typography variant="body2" style={{ marginTop: 8 }}>{i18n.t("messagesAPI.section5.seeGuide")}</Typography>
                </Typography>
              </Alert>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Paper>
  );
};

export default MessagesAPI;
